// Base and resolved stats. See docs/02-party-character §2.6 and docs/06-level-xp §6.10-6.13.
export const STAT_KEYS = ['str', 'dex', 'int', 'vit', 'wis'];
export const STAT_GROWTH_VALUE = {
    low: 0.5,
    mid: 1.0,
    high: 1.5,
};
/** Power multiplier curve from docs/06-level-xp §6.10: powerMult(Lv) = (1 + Lv*0.05)^1.2. */
export function powerMult(level) {
    return Math.pow(1 + level * 0.05, 1.2);
}
export const STAT_CURVE_BY_TIER = {
    1: { Lmax: 400, tau: 150 },
    2: { Lmax: 700, tau: 300 },
    3: { Lmax: 1000, tau: 450 },
    4: { Lmax: 1300, tau: 600 },
};
/**
 * Coefficient A for the permanent-stat formula.
 *   permanentBonus[stat] = growth_value * A * statContribution(jobMaxLv, tier)
 *
 * Pinned at 0.05 by ADR 0004 §3.3 and confirmed under the Tier-curve regime
 * by ADR 0006 §2.3 (44-job whale lands at +1,731 with this coefficient).
 *
 * Lives in @renavora/shared so both the sim runtime and content helpers can
 * use it without a cross-package dependency.
 */
export const PERMANENT_STAT_BONUS_COEFF = 0.05;
/**
 * Per-Tier stat-contribution from a job level. ADR 0006 §2.2.
 *
 * Used by:
 *   - current job stat scaling (packages/sim/src/stats-resolver.ts)
 *   - permanent stat bonus from past jobs (packages/content/src/level/job-xp.ts)
 *
 * Both share the same curve family for consistency: a job grinded to Lv L
 * contributes Lmax(tier) * (1 - exp(-L / tau(tier))) per growth_value unit.
 */
export function statContribution(jobLevel, tier) {
    if (!Number.isFinite(jobLevel)) {
        throw new RangeError(`jobLevel must be finite, got ${String(jobLevel)}`);
    }
    if (jobLevel < 0) {
        throw new RangeError(`jobLevel must be >= 0, got ${jobLevel}`);
    }
    const curve = STAT_CURVE_BY_TIER[tier];
    if (!curve) {
        throw new RangeError(`unknown JobTier: ${String(tier)}`);
    }
    return curve.Lmax * (1 - Math.exp(-jobLevel / curve.tau));
}
//# sourceMappingURL=stats.js.map